import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { HomePageCarouselPromos } from 'src/domains/layouts/webview/components/homePageCarouselPromos/HomePageCarouselPromos';
import { HtmlElementReactive } from 'src_common/common/mobx-utils/HtmlElementReactive';
import { computed, makeObservable } from 'mobx';
import { LoadingWrapper } from 'src/domains/layouts/shared/loaders';
import {
    CarouselModeType,
    HomePageCarouselState,
} from 'src/domains/layouts/state/cmsState/homePageCarouselState/HomePageCarouselState';
import { useCommon } from 'src/domains/common/Common';

const DEFAULT_HEIGHT = 200;
class CarouselPromoState {
    public readonly reactiveWrapper: HtmlElementReactive<HTMLElement> = new HtmlElementReactive(500);

    public constructor() {
        makeObservable(this);
    }

    @computed public get elementRefHeight(): number {
        const elementRef = this.reactiveWrapper.ref;
        return elementRef?.clientHeight ?? DEFAULT_HEIGHT;
    }
}

interface PropsType {
    modeType: CarouselModeType;
}

export const CarouselPromo = observer('CarouselPromo', (props: PropsType) => {
    const common = useCommon();
    const { modeType } = props;
    const [state] = useState(() => new CarouselPromoState());

    const homepageCarouselState = HomePageCarouselState.get(common, modeType);

    return (
        <LoadingWrapper computedHeight={state.elementRefHeight}>
            <div ref={state.reactiveWrapper.setRef}>
                <HomePageCarouselPromos
                    state={homepageCarouselState}
                    modeType={modeType}
                />
            </div>
        </LoadingWrapper>
    );
});
